module.exports = __webpack_public_path__ + "static/projects-b713455d3d145acf9ef31d973bbe72cf.jpg";